import {
  EXP_PROVIDER_ASPIRE,
  EXP_PROVIDER_ASPIRE_PREFIX,
  EXP_PROVIDER_COLLINSON,
  EXP_PROVIDER_COLLINSON_PREFIX,
  EXP_PROVIDER_CUSTOMLINC,
  EXP_PROVIDER_CUSTOMLINC_PREFIX,
  EXP_PROVIDER_DERBYSOFT,
  EXP_PROVIDER_DERBYSOFT_PREFIX,
  EXP_PROVIDER_KLOOK,
  EXP_PROVIDER_KLOOK_PREFIX,
  EXP_PROVIDER_LED,
  EXP_PROVIDER_LED_PREFIX,
  EXP_PROVIDER_REZDY,
  EXP_PROVIDER_REZDY_PREFIX,
} from '~/consts/experiences';

const experienceVendorFormatter = (provider: string) => {
  switch (provider) {
    case 'mus':
      return 'Musement';
    case EXP_PROVIDER_LED_PREFIX:
      return EXP_PROVIDER_LED;
    case EXP_PROVIDER_REZDY:
      return EXP_PROVIDER_REZDY_PREFIX;
    case EXP_PROVIDER_DERBYSOFT_PREFIX:
      return EXP_PROVIDER_DERBYSOFT;
    case EXP_PROVIDER_KLOOK_PREFIX:
      return EXP_PROVIDER_KLOOK;
    case EXP_PROVIDER_ASPIRE_PREFIX:
      return EXP_PROVIDER_ASPIRE;
    case EXP_PROVIDER_COLLINSON_PREFIX:
      return EXP_PROVIDER_COLLINSON;
    case EXP_PROVIDER_CUSTOMLINC_PREFIX:
      return EXP_PROVIDER_CUSTOMLINC;
    default:
      return 'Addon';
  }
};

export default experienceVendorFormatter;
